__webpack_require__.p = "https://tapc.studio/_next/";